import React from "react";
import ReactSelect from "react-select";
import Datetime from "react-datetime";
import Moment from "moment";
import { Option } from '../../../_metronic/helpers/MySelect';
import Select from "react-select";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { accountTypeDB, isVipDB, statusDB } from "./CustomersList";

interface CustomerFilterProps {
  state: any;
  setState: React.Dispatch<React.SetStateAction<any>>;
  searchData: () => void;
  removeSearch: () => void;
}

const CustomerFilter: React.FC<CustomerFilterProps> = ({
  state,
  setState,
  searchData,
  removeSearch,
}) => {
    const getLabelForStatus = (status: any): string => {
        if (status === "true") {
            return "Active";
          } else if (status === "false") {
            return "Inactive";
          } else if (status === "all") {
            return "All";
          } else {
            return "Active";
          }
      };
      const getLabelForIsVip = (isVip: any): string => {
        if (isVip === "true") {
            return "Yes";
          } else if (isVip === "false") {
            return "No";
          } else {
            return "";
          }
      };
  return (
      <div className="collapse" id="customer-filter" aria-labelledby="customer-filter">
                   <div className="card mt-9">
              <div className="card-body w-100 p-lg-7 p-md-7 p-5">
                  <div className="row mt-6">
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 ps-xl-5 mb-3">
                      <label className="form-label fs-4 fw-bold">Created At (From Date)</label>
                      <Datetime
                        ref={state.resetFrom}
                        closeOnSelect
                        dateFormat="YYYY-MM-DD"
                        timeFormat="HH:mm"
                        value={state.filterFromDate ? Moment(state.filterFromDate).format("YYYY-MM-DD HH:mm") : ""}
                        onChange={(e: any) => {
                          const dt = e["_d"];
                          setState({
                            filterFromDate: dt,
                          });
                        }}
                      />
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                      <label className="form-label fs-4 fw-bold">Created At (To Date)</label>
                      <Datetime
                        ref={state.resetTo}
                        closeOnSelect
                        dateFormat="YYYY-MM-DD"
                        timeFormat="HH:mm"
                        value={state.filterToDate ? Moment(state.filterToDate).format("YYYY-MM-DD HH:mm") : ""}
                        onChange={(e: any) => {
                          const dt = e["_d"];
                          setState({
                            filterToDate: dt,
                          });
                        }}
                      />
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                      <label className="form-label fs-4 fw-bold">Distributor</label>
                      <ReactSelect
                        className="react-select"
                        classNamePrefix="my-react-select"
                        placeholder=""
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        onChange={(selected: any) => {
                          const value = selected?.map((e: any) => e.value);
                          setState({
                            distributorSelected: selected,
                            filterDistributer: value,
                          });
                        }}
                        components={{
                          Option,
                        }}
                        value={state.distributorSelected}
                        options={Array.from(state.distributorDB).map(
                          (value: any) => {
                            return {
                              value: value.id,
                              label: value.name,
                            };
                          }
                        )}
                      />
                    
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                      <label className="form-label fs-4 fw-bold">Account Type</label>
                      <ReactSelect
                        className="react-select"
                        classNamePrefix="my-react-select"
                        placeholder=""
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        onChange={(selected: any) => {
                          const value = selected?.map((e: any) => e.value);
                          setState({
                            accountTypeSelected: selected,
                            filterAccountType: value,
                          });
                        }}
                        components={{
                          Option,
                        }}
                        value={state.accountTypeSelected} // Ensure this reflects the selected values
                        options={Array.from(accountTypeDB).map(
                          (value: any) => {
                            return {
                              value: value.id,
                              label: value.name,
                            };
                          }
                        )}
                      />
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                      <label className="form-label fs-4 fw-bold">Customer Name</label>
                      <ReactSearchAutocomplete
                        items={state.customerDB.map((customer: any) => ({ name: customer.name, id: customer.name }))}
                        onSelect={(item: any) => {
                          setState({
                            filterName: item.name,
                          });
                        }}
                        onSearch={(keyword) => {
                          setState({
                            filterName: keyword,
                          });
                        }}
                        inputSearchString={state.filterName }
                        autoFocus
                        styling={{
                          borderRadius: '5px',
                          zIndex: 1
                        }}
                        fuseOptions={{
                          threshold: 0.2,
                        }}
                        onClear={() => {
                          setState({
                            filterName: '',
                          });
                        }}
                      />
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                      <label className="form-label fw-bold fs-4">Customer Status</label>
                      <Select
                        ref={state.resetStatus}
                        className="react-select"
                        classNamePrefix="my-react-select"
                        name="filterStatus"
                        defaultValue={{
                          label: getLabelForStatus(state.filterStatus), 
                          value: state.filterStatus 
                        }}
                        placeholder=""
                        onChange={(event: any) => {
                          setState({
                            filterStatus: event.value,
                          });
                        }}
                        options={Array.from(statusDB).map((value: any) => {
                          return {
                            value: value.id,
                            label: value.name,
                          };
                        })}
                      />
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3">
                      <label className="form-label fw-bold fs-4">Is VIP</label>
                      <Select
                        ref={state.resetIsVip}
                        className="react-select"
                        classNamePrefix="my-react-select"
                        name="filterIsVip"
                        defaultValue={{
                          label: getLabelForIsVip(state.filterIsVip), 
                          value: state.filterIsVip 
                        }}
                        placeholder=""
                        onChange={(event: any) => {
                          setState({
                            filterIsVip: event.value,
                          });
                        }}
                        options={Array.from(isVipDB).map((value: any) => {
                          return {
                            value: value.id,
                            label: value.name,
                          };
                        })}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3 mb-lg-4">
                      <button
                        type="submit"
                        onClick={searchData}
                        className="btn btn-primary me-4 fs-4 p-0 w-100 px-6 py-3"
                      >
                        {state.addLoading && (
                          <span
                            className="indicator-progress"
                            style={{ display: "block" }}
                          >
                            Please Wait..
                            <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                          </span>
                        )}
                        {!state.addLoading && (
                          <span className="indicator-label">ADD FILTER</span>
                        )}
                      </button>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3 mb-lg-4">
                      <button
                        type="submit"
                        onClick={removeSearch}
                        className="btn btn-primary me-4 fs-4 p-0 w-100 px-6 py-3"
                      >
                        {state.filterLoading && (
                          <span
                            className="indicator-progress"
                            style={{ display: "block" }}
                          >
                            Please Wait..
                            <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                          </span>
                        )}
                        {!state.filterLoading && (
                          <span className="indicator-label">RESET FILTER</span>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  );
};

export default CustomerFilter;